import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomGridComponent } from './custom-grid.component';

import { ChartModule } from '../../shared/components/chart/chart.module';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { DataGridModule } from '../../shared/components/data-grid/data-grid.module';



@NgModule({
    declarations: [CustomGridComponent],

    imports: [
    DataGridModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ChartModule, NzCardModule, NzModalModule
    ],

    exports: [
        CustomGridComponent
    ]

})

export class CustomGridModule {


}